import React, { Component } from "react";
import Cost_centerForm from "../Cost_centerForm/Cost_centerForm";
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : AccountingPage
Description : Componente que contienen el formulario de la pantalla Accounting 
Date Autor Modification
================================================================================
04/11/2021 Cristian Andres Pizo Mina – Se llama al componente AccountingForm
================================================================================ */
class Cost_centerPage extends Component{
    render(){
        return(
            <div>                    
                <Cost_centerForm/>
            </div>
        )   
    }
}

export default Cost_centerPage;